// app/javascript/modules/sidebar.js

function initSidebar() {
  var sidebar = document.getElementById('admin-sidebar');
  var sidebarToggle = document.getElementById('sidebar-toggle');
  var sidebarCollapse = document.getElementById('sidebar-collapse');
  var sidebarOverlay = document.getElementById('sidebar-overlay');

  if (!sidebar) return;

  // --- Desktop collapse/expand ---
  // Restore collapsed state from localStorage (desktop only)
  if (window.innerWidth >= 1024) {
    var collapsed = localStorage.getItem('sidebar-collapsed') === 'true';
    sidebar.setAttribute('data-collapsed', collapsed);
  }

  if (sidebarCollapse && sidebarCollapse.dataset.bound !== 'true') {
    sidebarCollapse.dataset.bound = 'true';
    sidebarCollapse.addEventListener('click', function() {
      var isCollapsed = sidebar.getAttribute('data-collapsed') === 'true';
      var newState = !isCollapsed;
      sidebar.setAttribute('data-collapsed', newState);
      localStorage.setItem('sidebar-collapsed', newState);
    });
  }

  // --- Mobile drawer ---
  if (sidebarToggle && sidebarToggle.dataset.bound !== 'true') {
    sidebarToggle.dataset.bound = 'true';
    sidebarToggle.addEventListener('click', function() {
      sidebar.classList.remove('-translate-x-full');
      if (sidebarOverlay) sidebarOverlay.classList.remove('hidden');
    });
  }

  // Click overlay to close mobile sidebar
  if (sidebarOverlay && sidebarOverlay.dataset.bound !== 'true') {
    sidebarOverlay.dataset.bound = 'true';
    sidebarOverlay.addEventListener('click', function() {
      sidebar.classList.add('-translate-x-full');
      sidebarOverlay.classList.add('hidden');
    });
  }
}

document.addEventListener('turbolinks:load', initSidebar);
